// extracted by mini-css-extract-plugin
export default {"imageWrapper":"wG-z","twoColumnImage":"xG-z"};